/**
 * @typedef {number} NotificationTypes
 **/

/**
 * Supported notification types.
 *
 * @enum {NotificationTypes}
 */
export const notificationTypes = Object.freeze({
  /**
   * Auction in tab _registered auctions_ is finishing in 3 hours
   */
  registeredFinishingIn3h: 1,

  /**
   * Direct Sale from _watchlist_ is finishing in 3 hours.
   */
  watchlistDirectSaleFinishingIn3h: 2,

  /**
   * Auction from _watchlist_ is finishing in 3 hours.
   */
  watchlistAuctionFinishingIn3h: 3,

  /**
   * Deposit pending.
   */
  depositPending: 4,

  /**
   * Deposit received.
   */
  depositReceived: 5,

  /**
   * New high bidder.
   */
  overbid: 6,

  /**
   * User won a lot.
   */
  winner: 7,

  /**
   * Seller attached invoice.
   */
  invoiceAttached: 8,

  /**
   * Inspection report for a lot from _registered auctions_ was received.
   */
  inspectionReportForRegisteredAuction: 9,

  /**
   * Inspection report for a direct sale from _watchlist_.
   */
  inspectionReportForWatchlistDirectSale: 10,

  /**
   * Inspection report for an auction from _watchlist_.
   */
  inspectionReportForWatchlistAuction: 11,

  /**
   * Carfax report for a lot from _registered auction_.
   */
  carfaxReportForRegistered: 12,

  /**
   * Carfax report for a direct sale from _watchlist_.
   */
  carfaxReportForWatchlistDirectSale: 13,

  /**
   * Carfax report for an auction from _watchlist_.
   */
  carfaxReportForWatchlistAuction: 14,

  /**
   * Direct sale request was approved.
   */
  directSaleApproved: 15,

  /**
   * Direct sale request was rejected.
   */
  directSaleRejected: 16,

  /**
   * Message from potential buyer of my direct sale lot.
   */
  messageFromBuyer: 17,

  /**
   * Message from the seller of the lot I want to buy.
   */
  messageFromSeller: 18,

  /**
   * User has requested a callback.
   */
  callbackRequested: 19,

  /**
   * User has registered on a lot(or requested buy now) and paid deposit.
   */
  newActiveTrade: 20,

  /**
   * User hase made a lot creation request.
   */
  newUpload: 21,

  /**
   * User paid for look live request.
   */
  lookLiveRequest: 22,

  /**
   * User bought a carfax report.
   */
  carfaxPurchase: 23,

  /**
   * Auction is ending in 3 h but there 's participant with unpaid deposit.
   */
  reminderUnpaidDeposit3h: 24,

  /**
   * Invoice is still 'due' 12h after lot is closed.
   */
  reminderUnpaidInvoice: 25,

  /**
   * Auction is finished.
   */
  auctionFinished: 26,

  /**
   * User 've just requested financing.
   */
  financingPending: 27,

  /**
   * Financing request is approved.
   */
  financingApproved: 28,

  /**
   * Financing request is rejected
   */
  financingRejected: 29
})
